import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { MacroPill } from 'domains/reporter/Macro/components';
import styled from 'styled-components';

type MacroTooltipHeaderProps = {
  macroName: string;
  compact?: boolean;
};

export const MacroTooltipHeader = ({
  macroName,
  compact = false,
}: MacroTooltipHeaderProps): React.ReactElement => {
  return (
    <Stack alignY="start" alignX="between">
      <Text variant="display1" css={{ minWidth: 0, flex: 1 }}>
        <TooltipTitle>{macroName}</TooltipTitle>
      </Text>
      <MacroPill label="Macro" size={compact ? 'xs' : 'sm'} />
    </Stack>
  );
};

const TooltipTitle = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
